import React from 'react';
import {Link} from 'react-router-dom';
import ContentWrapper from '../Layout/ContentWrapper';
import {Row, Col, Button} from 'reactstrap';
import Swal from 'sweetalert2'
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import moment from 'moment';
import 'moment-timezone';
import {getEquipment} from "../Equipment/EquipmentFunctions";
import getLocations from "../Locations/LocationFunctions";
import ReactSpeedometer from "react-d3-speedometer"

moment.tz.setDefault("America/Halifax");

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            equipment: [],
            vehicles: {},
            vehicles_sort: [],
            loading: true,
            locations: {locations: {}, locations_sort: []},
            pings: [],
            loads:{0:0, 1:0, 2:0, 3:0, 4:0},
            utilization: {},
            mpg: []
        };
    }

    componentDidMount() {
        var self = this;
        getEquipment(0,function (equipment) {
            getLocations(function (locations) {
                self.setState({
                    locations: locations,
                    equipment: equipment
                });
                axios.get(API_ROOT + '/equipment/pings?id=' + moment().unix())
                    .then(function (response) {
                        self.setState({
                                pings: response.data,
                                loading: false,
                                last_update: moment()
                            },
                        );
                    })
                axios.get(API_ROOT + '/utilization')
                    .then(function (response) {
                        self.setState({
                                utilization: response.data,
                            },
                        );
                    })
                axios.get(API_ROOT + '/loads/summary')
                    .then(function (response) {
                        self.setState({
                                loads: response.data,
                            },
                        );
                    })
                axios.get(API_ROOT + '/equipment/mpg')
                    .then(function (response) {
                        self.setState({
                                mpg: response.data,
                            },
                        );
                    })
            });
        });
    }

    viewLoads = (status) => {
        localStorage.setItem('status', status);
        this.props.history.push("/loads");
    }

    render() {
        var now = moment();
        var quarter = now.quarter();
        var year = now.year();
        var last_quarter = quarter - 1;
        var last_year = year;
        if (last_quarter == 0) {
            last_quarter = 4;
            last_year = year - 1;
        }
        var selected_yards = [1,196];
        var trucks_at_selected_yards = [];
        var num_oos = 0;
        var utilized_total = Object.values(this.state.utilization).reduce((acc, val) => acc + val, 0);
        var utilized_total_possible = Object.keys(this.state.utilization).length;
        var utilization = (utilized_total / utilized_total_possible);
        if (isNaN(utilization)) {
            utilization = 0;
        }
        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>
                        Dashboard
                    </div>
                </div>
                <Row>
                    <div className="col-lg-6">
                        <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                            <div>
                                <div className="card-header pb-0">
                                    <div className="card-title">Load Summary
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="row text-center">
                                        <div className="col bg-gray rounded m-1" style={{cursor: "pointer", color:"#fff !important"}} onClick={() => this.viewLoads(0)}>
                                            Draft
                                            <h1>{(typeof this.state.loads[0] == "undefined" ? 0 : this.state.loads[0])}</h1>
                                        </div>
                                        <div className="col bg-info rounded m-1" style={{cursor: "pointer"}} onClick={() => this.viewLoads(1)}>
                                            Scheduled
                                            <h1>{(typeof this.state.loads[1] == "undefined" ? 0 : this.state.loads[1])}</h1>
                                        </div>
                                        <div className="col bg-warning rounded m-1" style={{cursor: "pointer"}} onClick={() => this.viewLoads(2)}>
                                            Started
                                            <h1>{(typeof this.state.loads[2] == "undefined" ? 0 : this.state.loads[2])}</h1>
                                        </div>
                                        <div className="col bg-success rounded m-1" style={{cursor: "pointer"}} onClick={() => this.viewLoads(3)}>
                                            Completed
                                            <h1>{(typeof this.state.loads[3] == "undefined" ? 0 : this.state.loads[3])}</h1>
                                        </div>
                                        <div className="col bg-pink text-light rounded m-1" style={{cursor: "pointer"}} onClick={() => this.viewLoads(4)}>
                                            Billed
                                            <h1>{(typeof this.state.loads[4] == "undefined" ? 0 : this.state.loads[4])}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={(this.state.loading ? "card card-default whirl traditional mb-2" : "card card-default mb-2")}>
                            <div>
                                <div className="card-header pb-0">
                                    <div className="card-title">Main Yards</div>
                                </div>
                                <div className="card-body pt-0">
                                    <table className={(this.state.locations.locations_sort.length > 0 ? "table table-sm table-hover table-pointer text-right" : "d-none")}
                                           style={{tableLayout: 'fixed'}}>
                                        <thead>
                                        <tr>
                                            <th className="text-left" width="33%">Name</th>
                                            <th className="text-left">Trucks</th>
                                            <th className="text-left">Trailers</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {selected_yards.map((location_id, key) => {
                                            if (typeof this.state.locations.locations[location_id] != "undefined") {
                                                var location = this.state.locations.locations[location_id];
                                                var i1 = 0;
                                                var i2 = 0;
                                                return (
                                                    <tr key={key}>
                                                        <td className="text-left">{location.name}</td>
                                                        <td className="text-left text-wrap" style={{wordWrap: 'break-word'}}>
                                                            {Object.entries(this.state.equipment).map(([equipment_id]) => {
                                                                if (typeof this.state.pings[equipment_id] != "undefined" && typeof this.state.pings[equipment_id][0] != "undefined" && this.state.pings[equipment_id][0].desc == location.name) {
                                                                    if (this.state.equipment[equipment_id].is_vehicle == 1 && this.state.equipment[equipment_id].status != 0) {
                                                                        trucks_at_selected_yards.push(equipment_id);
                                                                        i1++;
                                                                        return (
                                                                            <>
                                                                                <span className={(i1 == 1 ? "d-none" : "")}>, </span>
                                                                                <Link to={"../vehicles/" + equipment_id}
                                                                                      className={(this.state.equipment[equipment_id].status == 2 ? "text-danger" : "")}>{this.state.equipment[equipment_id].name}</Link>
                                                                            </>
                                                                        )
                                                                    }
                                                                }
                                                            })}
                                                        </td>
                                                        <td className="text-left text-wrap" style={{wordWrap: 'break-word'}}>
                                                            {Object.entries(this.state.equipment).map(([equipment_id]) => {
                                                                if (typeof this.state.pings[equipment_id] != "undefined" && typeof this.state.pings[equipment_id][0] != "undefined" && this.state.pings[equipment_id][0].desc == location.name) {
                                                                    if (this.state.equipment[equipment_id].is_vehicle != 1) {
                                                                        i2++;
                                                                        return (
                                                                            <>
                                                                                <span className={(i2 == 1 ? "d-none" : "")}>, </span>
                                                                                <Link to={"../equipment/" + equipment_id}
                                                                                      className={(this.state.equipment[equipment_id].status == 2 ? "text-danger" : "")}>{this.state.equipment[equipment_id].name}</Link>
                                                                            </>
                                                                        )
                                                                    }
                                                                }
                                                            })}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                            <div>
                                <div className="card-header pb-0">
                                    <div className="card-title">Out of Service Trucks
                                        <i className="small float-right"><i className="fa fa-suitcase text-muted"></i> = Not at a Main Yard</i>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    {Object.entries(this.state.equipment).map(([equipment_id, i]) => {
                                        if (this.state.equipment[equipment_id].is_vehicle == 1 && this.state.equipment[equipment_id].status == 2) {
                                            num_oos++;
                                            return (
                                                <>
                                                    <span className={(num_oos == 1 ? "d-none" : "")}>, </span>
                                                    <Link to={"../vehicles/" + equipment_id}>{this.state.equipment[equipment_id].name}</Link><i
                                                    className={(!trucks_at_selected_yards.includes(equipment_id) ? "fa fa-suitcase ml-1 text-muted" : "")}/>
                                                </>
                                            )
                                        }
                                    })}
                                    <div className={(num_oos == 0 && !this.state.loading ? "alert alert-success pt-1 pb-1 mb-0" : "d-none")}><i
                                        className="fas fa-check fa-lg mr-2"></i> No OOS trucks
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-6">
                        <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                            <div>
                                <div className="card-header pb-0">
                                    <div className="card-title">Truck Utilization Rate (1 Week)</div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="w-100 text-center" style={{height: "180px", width: "400px"}}>
                                        <ReactSpeedometer
                                            customSegmentStops={[0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1]}
                                            segmentColors={["firebrick", "firebrick", "firebrick", "firebrick", "firebrick", "gold", "limegreen", "limegreen", "gold", "firebrick"]}
                                            value={utilization}
                                            currentValueText={`${Math.round(utilization * 100)}%`}
                                            minValue={0}
                                            valueFormat=".0%"
                                            needleTransition="easeElastic"
                                            maxValue={1}
                                        />
                                    </div>
                                    <table className="table table-sm">
                                        <tbody>
                                        <tr>
                                            {Object.entries(this.state.utilization).map(([day, rate]) => {
                                                return (
                                                    <td className="text-center">
                                                        <b>{day}</b><br/>{Math.round(rate * 100)}%
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className={(this.state.loading ? "card card-default whirl traditional mt-2" : "card card-default mt-2")}>
                            <div>
                                <div className="card-header pb-0">
                                    <div className="card-title">Last Quarter MPG (Q{last_quarter} {last_year})</div>
                                </div>
                                <div className="card-body pt-0">
                                    <table className={(this.state.mpg.length > 0 ? "table table-sm table-hover" : "d-none")}>
                                        <thead>
                                        <tr>
                                            <th className="text-left">Truck</th>
                                            <th className="text-right">KM</th>
                                            <th className="text-right">Litres</th>
                                            <th className="text-right">MPG</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.mpg.map((row) => {
                                            return (
                                                <tr key={row.equipment_id}>
                                                    <td className="text-left"><Link to={"../vehicles/" + row.equipment_id}>{row.name}</Link></td>
                                                    <td className="text-right">{(row.distance_km != null ? Math.round(row.distance_km).toLocaleString() : '—')}</td>
                                                    <td className="text-right">{(row.total_litres > 0 ? Math.round(row.total_litres).toLocaleString() : '—')}</td>
                                                    <td className="text-right">{(row.mpg != null ? row.mpg.toFixed(1) : '—')}</td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td className="text-left"><b>Total</b></td>
                                            <td className="text-right"><b>{Math.round(this.state.mpg.reduce((acc, row) => acc + (row.distance_km || 0), 0)).toLocaleString()}</b></td>
                                            <td className="text-right"><b>{Math.round(this.state.mpg.reduce((acc, row) => acc + (row.total_litres || 0), 0)).toLocaleString()}</b></td>
                                            <td className="text-right"><b>—</b></td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                    <div className={(this.state.mpg.length == 0 && !this.state.loading ? "alert alert-info pt-1 pb-1 mb-0" : "d-none")}>
                                        <i className="fas fa-info-circle mr-2"></i> No MPG data available
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>
            </ContentWrapper>
        );
    }
}

export default (Dashboard);
